"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const ProviderClinicHours = ({ periods, intl }) => {
    const presentDay = (0, utils_1.getCurrentDay)('dddd');
    const presentTime = (0, moment_1.default)().format('HH:mm');
    const hoursAvailability = (0, utils_1.getProviderClinicAvailability)(periods, presentDay, presentTime, intl);
    if (!hoursAvailability) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, hoursAvailability === null || hoursAvailability === void 0 ? void 0 : hoursAvailability.map((i) => (react_1.default.createElement("li", { key: i },
        react_1.default.createElement(styles_1.LocationInfoItem, null,
            react_1.default.createElement("time", { itemProp: "openingHours" }, i)))))));
};
exports.default = (0, intl_1.injectIntl)(ProviderClinicHours);
//# sourceMappingURL=provider-hours.js.map